// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pricePage{background-color:#dae3ea}.price__table-gray{background-color:#e8eaeb;color:#474747}.price__table-lightGray{background-color:#dee1e2}.price__table-light{background-color:#f5f5f5}", ""]);
// Exports
module.exports = exports;
